import { mapState, mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters('browse', ['userBrowseHeaders']),
    ...mapState('browse', ['showNavBrowseOverlay'])
  },
  methods: {
    ...mapActions('browse', ['toggleNavBrowseCategoriesOverlay']),
    closeOverlay() {
      this.toggleNavBrowseCategoriesOverlay();
    },
  },
  watch: {
    showNavBrowseOverlay(value) {
      const action = value ? 'add' : 'remove';
      document.documentElement.classList[action]('modal-open');
      document.body.classList[action]('modal-open');
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/app/app-secondary-nav/nav-browse-categories-overlay/nav-browse-categories-overlay.js